import { useDispatch } from 'react-redux';
import ComplainsForm from '../../common/ComplainsForm/ComplainsForm';
import { useNavigate, useParams } from 'react-router-dom';
import { useEffect, useState } from 'react';

import {
  editPackageRequest,
  loadPackageByIdRequest,
} from '../../../redux/packagesRedux';
import { useTranslation } from 'react-i18next';
const EditPackageForm = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams();

  const [area, setArea] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const start = async () => {
      const res = await dispatch(loadPackageByIdRequest(id));
      setArea(res.data);
      setLoading(false);
    };
    start();
  }, [dispatch]);

  const handleSubmit = async (data) => {
    await dispatch(editPackageRequest({ ...data, id }));
    navigate('/opakowanie');
  };

  if (!loading) {
    return (
      <ComplainsForm
        action={handleSubmit}
        {...area}
        actionText={t('package.edit')}
        buttonText={t('button.edit')}
      />
    );
  }
};

export default EditPackageForm;
